import { LinkType } from '@easeltv/analytics';
import { MenuLink, RegistrationMode } from '@easeltv/client-sdk';
import { useDropdown } from '@easeltv/hooks';

import { useConfig } from '../../../hooks/useConfig/useConfig';
import { useAuth } from '../../../providers/AuthProvider/AuthProvider';
import DumbContextMenuBlock from './ContextMenuBlock.dumb';

interface ContextMenuBlockProps {
    /** Menu items to display when the user is logged in */
    loggedInItems: MenuLink[];

    /** Menu items to display when the user is logged out */
    loggedOutItems: MenuLink[];

    /** Callback to track menu link clicks */
    trackMenuLinkClicked: (
        menuSource: string,
    ) => (destination: LinkType) => void;
}

/* -------------------------------- Component ------------------------------- */

const ContextMenuBlock = ({
    loggedInItems,
    loggedOutItems,
    trackMenuLinkClicked,
}: ContextMenuBlockProps) => {
    const { isAuthenticated } = useAuth();
    const { containerRef, showDropdown, toggleDropdown } = useDropdown();
    const {
        registration: { mode },
    } = useConfig();

    // Account buttons should only display if auth is enabled
    const registrationEnabled = mode !== RegistrationMode.Disabled;

    return (
        <DumbContextMenuBlock
            isAuthenticated={isAuthenticated}
            containerRef={containerRef}
            showDropdown={showDropdown}
            toggleDropdown={toggleDropdown}
            loggedInItems={loggedInItems}
            loggedOutItems={loggedOutItems}
            registrationEnabled={registrationEnabled}
            trackMenuLinkClicked={trackMenuLinkClicked}
        />
    );
};

/* --------------------------------- Export --------------------------------- */

export default ContextMenuBlock;
